import { render, staticRenderFns } from "./trusteeship-confirm.vue?vue&type=template&id=362f856c"
import script from "./trusteeship-confirm.vue?vue&type=script&lang=js"
export * from "./trusteeship-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports